import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IDeleteUncroppedUntriagedClipsResponse } from './delete-uncropped-untriaged-clips-response';
import { deleteUncroppedUntriagedClipsResponseSchema } from './delete-uncropped-untriaged-clips-response';

export async function deleteUncroppedUntriagedClipsApi(
  collectionId: number,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IDeleteUncroppedUntriagedClipsResponse>> {
  return postRequest<IDeleteUncroppedUntriagedClipsResponse>({
    path: `/sys/pipeline/${collectionId}/delete-uncropped-untriaged-clips`,
    schema: deleteUncroppedUntriagedClipsResponseSchema,
    options,
  });
}
